import api from "./api";
import { withActingInstitute } from "../utils/actingInstituteParam";

// Special-session endpoints resolve the institute server-side. For a Super Admin
// acting on a selected institute (dropdown-select flow, token has no operating
// context), the acting institute id must be sent or the backend resolver returns
// 400 "Institute not found". `withActingInstitute` appends it as an `instituteId`
// query param (no-op for admin/institute/teacher/hod, who resolve from their own
// token/profile). QR/OTP self check-in is student-scoped and resolves from the
// student's own record, so it is left untouched.
const specialSessionService = {
  create: (payload) => api.post("/special-sessions", payload, withActingInstitute()),
  list: (params) => api.get("/special-sessions", withActingInstitute({ params })),
  visible: (params) => api.get("/special-sessions/visible", withActingInstitute({ params })),
  getById: (id) => api.get(`/special-sessions/${id}`, withActingInstitute()),
  update: (id, payload) => api.put(`/special-sessions/${id}`, payload, withActingInstitute()),
  remove: (id, params) => api.delete(`/special-sessions/${id}`, withActingInstitute({ params })),
  start: (id) => api.post(`/special-sessions/${id}/start`, {}, withActingInstitute()),
  end: (id) => api.post(`/special-sessions/${id}/end`, {}, withActingInstitute()),
  reopen: (id) => api.post(`/special-sessions/${id}/reopen`, {}, withActingInstitute()),
  checkInByQr: (payload) => api.post("/special-sessions/checkin/qr", payload),
  checkInByOtp: (payload) => api.post("/special-sessions/checkin/otp", payload),
  manualMark: (id, payload) => api.post(`/special-sessions/${id}/attendees/manual`, payload, withActingInstitute()),
  listAttendees: (id, params) => api.get(`/special-sessions/${id}/attendees`, withActingInstitute({ params })),
  getAttendeeCount: (id) => api.get(`/special-sessions/${id}/attendees/count`, withActingInstitute()),
  exportAttendees: (id) => api.get(`/special-sessions/${id}/attendees/export`, withActingInstitute({ responseType: "blob" })),
  removeAttendee: (id, attendeeId) => api.delete(`/special-sessions/${id}/attendees/${attendeeId}`, withActingInstitute()),
  downloadExternalTemplate: () => api.get("/special-sessions/attendees/template", withActingInstitute()),
  importExternalAttendees: (id, formData, params) =>
    api.post(`/special-sessions/${id}/attendees/import`, formData, withActingInstitute({
      params,
      headers: { "Content-Type": "multipart/form-data" },
    })),
};

export default specialSessionService;

